// Prüfen in der Schadenmappe: die Zusammenfassung des Wizards, darüber, welche
// Pflichtangaben noch fehlen — je mit einem Sprung zum Schritt. Absenden gibt
// es intern nicht (die Mappe speichert laufend).
import * as React from "react";
import SummaryStep from "../../schadenmeldung-big/steps/SummaryStep";
import type { BigAnswers, BigStepKey } from "../../schadenmeldung-big/types";
import type { SchrittEintrag } from "./schritte";

export interface PruefenInternProps {
  answers: BigAnswers;
  /** Schritte mit unerfüllter Pflicht (von der Seite, unabhängig vom Besuch). */
  fehlende: SchrittEintrag[];
  onSchritt: (s: BigStepKey) => void;
  /** Kopf der Meldung: was in den ersten drei Schritten gewählt wurde. */
  kontakt?: { id: number; label: string } | null;
  risiko?: { id: number; label: string } | null;
  vertrag?: { id: number; label: string } | null;
  schadensart?: string | null;
}

export function PruefenIntern({ answers, fehlende, onSchritt, kontakt, risiko, vertrag, schadensart }: PruefenInternProps) {
  const kopf: Array<{ titel: string; wert: string; schritt: BigStepKey }> = [
    { titel: "Kontakt", wert: kontakt ? kontakt.label || `Kontakt #${kontakt.id}` : "", schritt: "kontakt" },
    { titel: "Konkrete Schadenart", wert: schadensart ?? "", schritt: "type" },
    { titel: "Risikoobjekt", wert: risiko ? risiko.label || `#${risiko.id}` : "", schritt: "risiko" },
    { titel: "Vertrag", wert: vertrag ? vertrag.label || `#${vertrag.id}` : "", schritt: "risiko" },
  ];
  return (
    <div className="smp-pruefen">
      {kontakt !== undefined && (
        <section className="smp-karte smp-pruef-kopf" aria-label="Kontakt, Risiko und Vertrag">
          <dl className="smp-pruef-liste">
            {kopf.map((z) => (
              <div key={z.titel} className="smp-pruef-zeile">
                <dt>{z.titel}</dt>
                <dd>
                  {z.wert || <span className="smp-hinweis">nicht gewählt</span>}
                  <button type="button" className="tbtn" onClick={() => onSchritt(z.schritt)}>
                    Ändern
                  </button>
                </dd>
              </div>
            ))}
          </dl>
        </section>
      )}
      {fehlende.length > 0 ? (
        <section className="smp-karte smp-fehlende" aria-label="Fehlende Pflichtangaben">
          <div className="smp-feld-titel">Es fehlen noch Pflichtangaben</div>
          <ul className="smp-fehlende-liste">
            {fehlende.map((f) => (
              <li key={f.key} className="smp-fehlende-zeile">
                <span className="smp-fehlende-label">{f.label}</span>
                <button type="button" className="tbtn" onClick={() => onSchritt(f.key)}>
                  Zum Schritt
                </button>
              </li>
            ))}
          </ul>
        </section>
      ) : (
        <section className="smp-karte smp-vollstaendig">Die Meldung ist vollständig.</section>
      )}
      <SummaryStep answers={answers} jumpTo={onSchritt} submitting={false} submitError={null} />
    </div>
  );
}
